import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .ip-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .ip-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .ip-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .ip-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(79,70,229,0.08), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .ip-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 700px; height: 700px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.07), rgba(79,70,229,0.04)); filter: blur(90px); pointer-events: none; }
  .ip-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .ip-hero-inner { grid-template-columns: 1fr; } .ip-hero-card { display: none; } }

  .ip-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #eef2ff; border: 1px solid #c7d2fe; font-size: 13px; font-weight: 500; color: #3730a3; margin-bottom: 28px; }
  .ip-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #4f46e5; display: inline-block; animation: ip-pulse 2s ease-in-out infinite; }
  @keyframes ip-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(79,70,229,0.5); } 50% { box-shadow: 0 0 0 6px rgba(79,70,229,0); } }

  .ip-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .ip-gradient-text { background: linear-gradient(135deg, #4f46e5 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .ip-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .ip-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .ip-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .ip-btn-primary:hover { background: #4f46e5; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(79,70,229,0.3); }
  .ip-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ip-btn-secondary:hover { border-color: #4f46e5; color: #3730a3; background: #eef2ff; }
  .ip-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .ip-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .ip-trust-check { width: 20px; height: 20px; background: #e0e7ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #4f46e5; flex-shrink: 0; }

  /* Hero Card */
  .ip-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .ip-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .ip-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .ip-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .ip-card-badge { background: #eef2ff; color: #3730a3; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .ip-asset-item { display: flex; align-items: center; justify-content: space-between; padding: 11px 14px; border-radius: 10px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; }
  .ip-asset-left { display: flex; align-items: center; gap: 10px; }
  .ip-asset-icon { font-size: 16px; }
  .ip-asset-name { font-size: 13px; font-weight: 600; color: #334155; }
  .ip-asset-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .ip-asset-badge { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .ip-badge-registered { background: #e0e7ff; color: #3730a3; }
  .ip-badge-pending { background: #fef9c3; color: #854d0e; }
  .ip-badge-active { background: #dcfce7; color: #166534; }
  .ip-card-metric { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #312e81, #4f46e5); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .ip-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .ip-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .ip-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats ── */
  .ip-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .ip-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .ip-stats-grid { grid-template-columns: 1fr 1fr; } }
  .ip-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .ip-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .ip-stat-item:nth-child(2n) { border-right: none; } .ip-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .ip-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #4f46e5; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .ip-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .ip-section { padding: 96px 24px; }
  .ip-container { max-width: 1200px; margin: 0 auto; }
  .ip-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .ip-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .ip-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .ip-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #4f46e5; margin-bottom: 12px; }

  /* ── IP Services ── */
  .ip-services-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ip-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .ip-services-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .ip-services-grid { grid-template-columns: 1fr; } }
  .ip-svc-card { background: #fff; padding: 32px 28px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .ip-svc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .ip-svc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; background: linear-gradient(90deg, #4f46e5, #7c3aed); }
  .ip-svc-card:hover::before { opacity: 1; }
  .ip-svc-icon { font-size: 28px; margin-bottom: 16px; }
  .ip-svc-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .ip-svc-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; margin-bottom: 14px; }
  .ip-svc-timeline { font-size: 11.5px; font-weight: 600; color: #4f46e5; background: #eef2ff; display: inline-block; padding: 3px 10px; border-radius: 999px; }

  /* ── Why Protect ── */
  .ip-why-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .ip-why-grid { grid-template-columns: 1fr; gap: 48px; } }
  .ip-why-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .ip-why-left p { font-size: 1rem; color: #64748b; line-height: 1.78; margin-bottom: 32px; }
  .ip-threat-items { display: flex; flex-direction: column; gap: 14px; }
  .ip-threat-item { display: flex; gap: 16px; padding: 16px 18px; background: #fff; border-radius: 14px; border: 1px solid #fecdd3; }
  .ip-threat-icon { width: 38px; height: 38px; border-radius: 10px; background: #fee2e2; display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0; }
  .ip-threat-title { font-size: 0.92rem; font-weight: 700; color: #991b1b; margin-bottom: 3px; }
  .ip-threat-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }
  .ip-benefit-items { display: flex; flex-direction: column; gap: 18px; }
  .ip-benefit-item { display: flex; gap: 14px; padding: 16px 18px; background: #eef2ff; border-radius: 14px; border: 1px solid #c7d2fe; }
  .ip-benefit-icon { width: 38px; height: 38px; border-radius: 10px; background: #e0e7ff; display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0; }
  .ip-benefit-title { font-size: 0.92rem; font-weight: 700; color: #0d1b3e; margin-bottom: 3px; }
  .ip-benefit-desc { font-size: 0.84rem; color: #64748b; line-height: 1.6; }

  /* ── Back Link ── */
  .ip-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #4f46e5; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .ip-back-btn:hover { color: #3730a3; }

  /* ── Process ── */
  .ip-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ip-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .ip-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .ip-process-grid { grid-template-columns: 1fr; } }
  .ip-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #4f46e5, #7c3aed); z-index: 0; }
  @media (max-width: 900px) { .ip-process-grid::before { display: none; } }
  .ip-process-step { text-align: center; position: relative; z-index: 1; }
  .ip-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .ip-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .ip-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .ip-cta { background: linear-gradient(135deg, #0d1b3e 0%, #312e81 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .ip-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(129,140,248,0.08); filter: blur(60px); pointer-events: none; }
  .ip-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .ip-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .ip-cta-tag { display: inline-block; background: rgba(129,140,248,0.18); border: 1px solid rgba(129,140,248,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #a5b4fc; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .ip-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .ip-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .ip-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .ip-cta-btn-primary { padding: 16px 32px; background: #4f46e5; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .ip-cta-btn-primary:hover { background: #4338ca; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(79,70,229,0.4); }
  .ip-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ip-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .ip-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .ip-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .ip-cta-check { width: 18px; height: 18px; background: rgba(129,140,248,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #a5b4fc; flex-shrink: 0; }
`;

const assetItems = [
  { icon: "™️", name: "BizServe™ Trademark", sub: "Registered · USPTO", badge: "Registered", badgeClass: "ip-badge-registered" },
  { icon: "©️", name: "Marketing Materials", sub: "Copyright filed 2024", badge: "Active", badgeClass: "ip-badge-active" },
  { icon: "💡", name: "Process Patent #4421", sub: "Application in review", badge: "Pending", badgeClass: "ip-badge-pending" },
  { icon: "🔐", name: "Trade Secrets Policy", sub: "Employee NDAs active", badge: "Active", badgeClass: "ip-badge-active" },
];

const ipServices = [
  { icon: "™️", title: "Trademark Registration", desc: "Protect your brand name, logo, and slogan from competitors with federal USPTO trademark registration and state-level filings.", timeline: "⏱ 8–12 months" },
  { icon: "©️", title: "Copyright Protection", desc: "Secure legal ownership of your creative works — marketing content, software code, photography, written materials, and more.", timeline: "⏱ 3–6 months" },
  { icon: "💡", title: "Patent Filing", desc: "Protect your inventions, product designs, and processes with utility, design, or provisional patent applications.", timeline: "⏱ 18–36 months" },
  { icon: "🔐", title: "Trade Secret Protection", desc: "Identify, document, and legally protect your proprietary processes, formulas, and business methods through NDAs and policy frameworks.", timeline: "⏱ Immediate" },
  { icon: "📄", title: "IP Licensing Agreements", desc: "Monetize your IP assets by licensing them to others under controlled terms — generating revenue while retaining full ownership.", timeline: "⏱ 2–4 weeks" },
  { icon: "🔍", title: "IP Portfolio Audit", desc: "Assess every IP asset your business owns, identify gaps in protection, and build a comprehensive strategy to strengthen your portfolio.", timeline: "⏱ 1–2 weeks" },
];

const threats = [
  { icon: "😤", title: "Brand Hijacking", desc: "Without a registered trademark, competitors can legally use your brand name, logo, or slogan — especially in other states or markets." },
  { icon: "💸", title: "Revenue Theft", desc: "Unprotected IP can be copied and monetized by competitors without any compensation to you — at massive scale." },
  { icon: "🚫", title: "Losing Legal Standing", desc: "If you haven't registered your IP, you lose the legal right to sue for infringement and cannot recover damages." },
];

const benefits = [
  { icon: "🏆", title: "Exclusive Market Rights", desc: "A registered trademark gives you nationwide exclusive rights to your brand — backed by the full force of federal law." },
  { icon: "💰", title: "Monetizable Assets", desc: "Protected IP can be licensed, sold, or used as collateral — turning your ideas into tangible balance-sheet assets." },
  { icon: "🛡️", title: "Infringement Deterrence", desc: "Publicly registered IP signals to competitors that copying you will have serious legal consequences — often preventing infringement entirely." },
  { icon: "📈", title: "Increased Business Value", desc: "Buyers and investors place significant value on protected IP portfolios when evaluating acquisitions and funding rounds." },
];

const processSteps = [
  { num: "01", title: "IP Audit", desc: "We identify every IP asset your business owns — trademarks, copyrights, patents, and trade secrets worth protecting." },
  { num: "02", title: "Protection Strategy", desc: "We recommend the right type and level of protection for each asset based on your business goals and risk exposure." },
  { num: "03", title: "Filing & Registration", desc: "We handle all applications, correspondence with the USPTO or Copyright Office, and responses to office actions." },
  { num: "04", title: "Monitor & Enforce", desc: "We monitor for infringement, send cease-and-desist letters, and take legal action if your IP is violated." },
];

const LegalIPPropertyProtection = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="ip-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="ip-hero">
        <div className="ip-hero-blob1" />
        <div className="ip-hero-blob2" />
        <div className="ip-hero-inner">
          <div>
            <button className="ip-back-btn" onClick={() => navigateTo("")}>
              ← Back to Legal Services
            </button>
            <div className="ip-badge">
              <span className="ip-badge-dot" />
              Intellectual Property Protection
            </div>
            <h1>
              Your Ideas Deserve{" "}
              <span className="ip-gradient-text">Legal Protection</span>
            </h1>
            <p className="ip-hero-sub">
              Your brand, creations, and inventions are among your most valuable
              business assets. We protect them with trademarks, copyrights,
              patents, and trade secret strategies — so competitors can't steal
              what you've built.
            </p>
            <div className="ip-btn-group">
              <button className="ip-btn-primary">Start IP Protection →</button>
              <button className="ip-btn-secondary">Get IP Audit</button>
            </div>
            <div className="ip-trust-items">
              {["Trademarks · Copyrights · Patents", "Trade secret strategies", "Infringement monitoring", "Enforcement support"].map((t, i) => (
                <div key={i} className="ip-trust-item">
                  <span className="ip-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="ip-hero-card">
            <div className="ip-card-header">
              <div>
                <div className="ip-card-title-label">Your Assets</div>
                <div className="ip-card-title-value">IP Portfolio</div>
              </div>
              <span className="ip-card-badge">4 Protected</span>
            </div>
            {assetItems.map((item, i) => (
              <div key={i} className="ip-asset-item">
                <div className="ip-asset-left">
                  <span className="ip-asset-icon">{item.icon}</span>
                  <div>
                    <div className="ip-asset-name">{item.name}</div>
                    <div className="ip-asset-sub">{item.sub}</div>
                  </div>
                </div>
                <span className={`ip-asset-badge ${item.badgeClass}`}>{item.badge}</span>
              </div>
            ))}
            <div className="ip-card-metric">
              <div>
                <div className="ip-metric-label">Estimated IP Portfolio Value</div>
                <div className="ip-metric-value">$420,000</div>
              </div>
              <div className="ip-metric-badge">↑ Growing</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="ip-stats">
        <div className="ip-stats-grid">
          {[
            { num: "3,200+", label: "IP Assets Protected" },
            { num: "97%", label: "Registration Success Rate" },
            { num: "150+", label: "Infringement Cases Won" },
            { num: "All 50", label: "States + International" },
          ].map((s, i) => (
            <div key={i} className="ip-stat-item">
              <div className="ip-stat-num">{s.num}</div>
              <div className="ip-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── IP Services ── */}
      <section className="ip-section ip-services-bg">
        <div className="ip-container">
          <div className="ip-section-header">
            <div className="ip-kicker">Our Services</div>
            <h2>Complete Intellectual Property Coverage</h2>
            <p>
              From your first trademark to a full IP portfolio strategy, we handle
              every form of intellectual property protection your business needs.
            </p>
          </div>
          <div className="ip-services-grid">
            {ipServices.map((svc, i) => (
              <div key={i} className="ip-svc-card">
                <div className="ip-svc-icon">{svc.icon}</div>
                <div className="ip-svc-title">{svc.title}</div>
                <div className="ip-svc-desc">{svc.desc}</div>
                <div className="ip-svc-timeline">{svc.timeline}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Threats + Benefits ── */}
      <section className="ip-section">
        <div className="ip-container">
          <div className="ip-why-grid">
            <div className="ip-why-left">
              <div className="ip-kicker">The Risks of Unprotected IP</div>
              <h2>What Happens When You Don't Protect Your IP</h2>
              <p>
                Many small businesses assume IP protection is only for large
                corporations. In reality, unprotected IP is one of the most
                exploited vulnerabilities in small business — here's why it matters.
              </p>
              <div className="ip-threat-items">
                {threats.map((t, i) => (
                  <div key={i} className="ip-threat-item">
                    <div className="ip-threat-icon">{t.icon}</div>
                    <div>
                      <div className="ip-threat-title">{t.title}</div>
                      <div className="ip-threat-desc">{t.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="ip-kicker">Why Protection Pays Off</div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#0d1b3e', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '32px' }}>
                The Strategic Value of Protecting Your IP
              </h2>
              <div className="ip-benefit-items">
                {benefits.map((b, i) => (
                  <div key={i} className="ip-benefit-item">
                    <div className="ip-benefit-icon">{b.icon}</div>
                    <div>
                      <div className="ip-benefit-title">{b.title}</div>
                      <div className="ip-benefit-desc">{b.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="ip-section ip-process-bg">
        <div className="ip-container">
          <div className="ip-section-header">
            <div className="ip-kicker">How It Works</div>
            <h2>From Audit to Fully Protected in 4 Steps</h2>
            <p>We assess, strategize, file, and monitor — giving your IP assets complete lifecycle protection.</p>
          </div>
          <div className="ip-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="ip-process-step">
                <div className="ip-process-num">{step.num}</div>
                <div className="ip-process-title">{step.title}</div>
                <div className="ip-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="ip-cta">
        <div className="ip-cta-blob1" />
        <div className="ip-cta-blob2" />
        <div className="ip-cta-inner">
          <div className="ip-cta-tag">Free IP Audit</div>
          <h2>Don't Let Competitors Steal What You've Built</h2>
          <p>
            Get a free IP audit and discover exactly which of your business assets
            are exposed. Our attorneys will map your entire IP landscape and
            recommend a protection strategy tailored to your goals.
          </p>
          <div className="ip-cta-btn-group">
            <button className="ip-cta-btn-primary">Get Free IP Audit</button>
            <button className="ip-cta-btn-secondary">Talk to an IP Attorney</button>
          </div>
          <div className="ip-cta-reassurances">
            {["Free audit", "All IP types covered", "International filings", "Infringement monitoring"].map((r, i) => (
              <div key={i} className="ip-cta-reassurance">
                <span className="ip-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalIPPropertyProtection;
